module.exports = __webpack_public_path__ + "media/images/default-508a753f886ddc91ecaff09323cb7bdd.jpg";